require('./RAInvestmentHorizonSlider.scss');

// @ vendors
const React = require('react');
const PropTypes = require('prop-types');
const Slider = require('rc-slider').default;
// @ components
const HighLightedText = require('components/highLightedText/highLightedText');
const RAInvestmentHorizonInput = require('../RAInvestmentHorizonInput/RAInvestmentHorizonInput');
const { InfoTooltip } = require('components/tooltip/tooltip');
// @ constants
const {
    RA_INVESTMENT_HORIZON_SLIDER_MIN,
    RA_INVESTMENT_HORIZON_SLIDER_MAX,
} = require('../../../../constants/RAConstants');
// @ utilities
import { FormattedText, formatText } from 'core/i18n';

class RAInvestmentHorizonSlider extends React.Component {
    render() {
        const {
            disabled,
            sliderValue,
            titleText,
            updateInvestmentHorizonSlider,
            recordEventInputClick,
            recordEventSliderClick,
            recordEventTooltipClick,
        } = this.props;

        return (
            <div className="ra-investment-horizon-slider">
                <div className="ra-investment-horizon-slider__head">
                    <div className="ra-investment-horizon-slider__title">
                        <h2>
                            {titleText}
                            <div className="tooltip-wrapper" onClick={recordEventTooltipClick}>
                                <InfoTooltip text={formatText('investmentTermSlider-tooltip')} />
                            </div>
                        </h2>
                    </div>
                </div>
                <div className="ra-investment-horizon-slider__term">
                    <RAInvestmentHorizonInput
                        value={sliderValue}
                        updateInvestmentHorizonSlider={updateInvestmentHorizonSlider}
                        disabled={disabled}
                        recordEventInputClick={recordEventInputClick}
                    />
                </div>
                <div className="ra-investment-horizon-slider__slider hidden-xs" onMouseDown={recordEventSliderClick}>
                    <Slider
                        min={RA_INVESTMENT_HORIZON_SLIDER_MIN}
                        max={RA_INVESTMENT_HORIZON_SLIDER_MAX}
                        value={sliderValue}
                        showTooltip={false}
                        onChange={updateInvestmentHorizonSlider}
                        disabled={disabled}
                    />
                </div>
                <div className="ra-investment-horizon-slider__disclaimer visible-xs">
                    <HighLightedText
                        className="form__hightlight-text form__hightlight-text--disclaimer"
                        icon={<i className="icons icons--icon-info-blue" />}
                    >
                        <FormattedText value={'investmentTermSlider-disclaimer'} />
                    </HighLightedText>
                </div>
                <div className="ra-investment-horizon-slider__labels hidden-xs">
                    <div className="ra-investment-horizon-slider__labels-year">
                        <FormattedText value={'investmentTermSlider-labelYear'} />
                    </div>
                    <div className="ra-investment-horizon-slider__labels-limit">
                        <FormattedText value={'investmentTermSlider-labelLimit'} />
                    </div>
                </div>
            </div>
        );
    }
}

RAInvestmentHorizonSlider.propTypes = {
    disabled: PropTypes.bool,
    sliderValue: PropTypes.number.isRequired,
    titleText: PropTypes.string,
    updateInvestmentHorizonSlider: PropTypes.func.isRequired,
};

module.exports = RAInvestmentHorizonSlider;
